import { render, staticRenderFns } from "./Loader-App.vue?vue&type=template&id=0b9e703b&scoped=true&"
var script = {}
import style0 from "./Loader-App.vue?vue&type=style&index=0&id=0b9e703b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e703b",
  null
  
)

export default component.exports